import React,{useEffect} from 'react'
import withView from '../../../cmn/docAutomation/withView';
import ItemCMNHeaderEditor from "./ItemCMNHeaderEditor"

const ItemShorthandMain = (props) => {
    const { formObject, viewData, formAction, closeModel, ...restProps} = props;

    const onSuccess = ()=>{
        closeModel();
    }

    const initialiseOnFormAction = () => {
        if(formAction && formAction.action){
            if (formAction.action === 'Save') {
                //fire form action with action id = save
                let saveAction = { actionId: "save", actionParam: { showModeID: 'sh' }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(saveAction, "", "");
            }
            else if (formAction.action === 'Cancel') {
                //fire form action with action id = cancel
                let cancelAction = { actionId: "cancel", actionParam: { showModeID: 'sh' }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(cancelAction, "", "");
            }
        }
    }

    useEffect(initialiseOnFormAction, [formAction]);

    if(!viewData)
        return(null);

    return (
        <div className="uiEditableContent uiShortHand">
            <ItemCMNHeaderEditor formObject={formObject} viewData={viewData} {...restProps}  />
        </div>
    )
}

export default withView(ItemShorthandMain, "itemComp", "")